import dayjs from 'dayjs'
import {
  isPlateReadObservation,
  PlatePage_CulturePlate,
  PlatePage_ObservationHistory,
} from '~/api/backend/pages/platePageAPI'
import MetadataSidebar, { MetadataItem } from '~/components/MetadataSidebar'
import cs from './plate_metadata_sidebar.scss'

export default function ObservationMetadataSidebar({
  plate,
  observation,
}: {
  plate: PlatePage_CulturePlate
  observation: PlatePage_ObservationHistory
}) {
  const firstCheckedInAt = dayjs(plate.firstCheckedInAt)
  const firstCheckedInThisYear = firstCheckedInAt.year() === dayjs().year()

  if (isPlateReadObservation(observation)) {
    return (
      <MetadataSidebar childClassName='!border-t-0'>
        <MetadataItem label='First Checked In'>
          {firstCheckedInAt.format(firstCheckedInThisYear ? 'MMM D' : 'MMM D, YYYY')}
          &ensp;
          {firstCheckedInAt.format('h:mm A')}&ensp;
          <span className={cs.secondary}>({firstCheckedInAt.fromNow()})</span>
        </MetadataItem>

        <MetadataItem label='Barcode'>{plate.barcode}</MetadataItem>
        <MetadataItem label='Measurement Wavelength'>
          {observation.absorbance_wavelength}nm
        </MetadataItem>
        <MetadataItem label='Control absorbance value'>
          {plate.control_absorbance}
        </MetadataItem>
        <MetadataItem label='Measurement Bandwidth'>
          {observation.absorbance_bandwidth > 0
            ? `${observation.absorbance_bandwidth}nm`
            : '-'}
        </MetadataItem>
        <MetadataItem label='Number of Reads'>
          {observation.number_of_reads > 0 ? observation.number_of_reads : '-'}
        </MetadataItem>
      </MetadataSidebar>
    )
  }
}
